export const COOKIE_NAME = 'redirect_state';
export default {
  set: (res, value) =>
    value &&
    res.cookie(COOKIE_NAME, JSON.stringify(value), {
      path: '/',
    }),
  get: (req) => JSON.parse(req.cookies.redirect_state || '{}'),
  delete: (res) =>
    res.cookie(COOKIE_NAME, '', {
      expires: new Date(),
    }),
};
